import React, { useState } from 'react';
import { MATCH_TYPES } from './matchTypesDatabase';

const tokenIcon = process.env.PUBLIC_URL + '/logistics/asset_token.png';

const LOGISTICS_UNLOCK_MAP = {
  'backstage-brawl':       { source: 'crew', rank: 2 },
  'last-man-standing':     { source: 'crew', rank: 2 },
  'ambulance':             { source: 'crew', rank: 3 },
  'no-holds-barred':       { source: 'crew', rank: 3 },
  'battle-royal':          { source: 'crew', rank: 4 },
  'dumpster':              { source: 'crew', rank: 4 },
  'steel-cage':            { source: 'sfx', rank: 2 },
  'gauntlet':              { source: 'sfx', rank: 2 },
  'gauntlet-eliminator':   { source: 'sfx', rank: 3 },
  'inferno':               { source: 'sfx', rank: 3 },
  'casket':                { source: 'sfx', rank: 4 },
  'i-quit':                { source: 'sfx', rank: 4 },
  'submission':            { source: 'advertising', rank: 2 },
  'tornado-tag':           { source: 'advertising', rank: 2 },
  'iron-man':              { source: 'advertising', rank: 3 },
  'underground':           { source: 'advertising', rank: 3 },
  'special-guest-referee': { source: 'advertising', rank: 4 },
  'bloodline-rules':       { source: 'advertising', rank: 4 },
};

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .log-card { transition: background 0.15s, border-color 0.15s; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
`;

const S = {
  anton: { fontFamily: "'Anton', sans-serif" },
  mono: { fontFamily: "'Monda', sans-serif" },
  panel: { background: 'rgba(8,8,8,0.88)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px' },
  label: { fontFamily: "'Monda', sans-serif", fontSize: '0.42rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase' },
};

export const LOGISTICS_DATA = {
  arena: {
    key: 'arena', label: 'Arena',
    icon: '/logistics/arena.png',
    ranks: [
      { rank: 1, name: 'High School Gym',  file: 'arena_rank1', tokens: 0,  price: 0,      isDefault: true },
      { rank: 2, name: 'Concert Hall',     file: 'arena_rank2', tokens: 3,  price: 100000 },
      { rank: 3, name: 'Wrestling Center', file: 'arena_rank3', tokens: 6,  price: 150000 },
      { rank: 4, name: 'Classic Arena',    file: 'arena_rank4', tokens: 9,  price: 250000 },
      { rank: 5, name: 'Stadium',          file: 'arena_rank5', tokens: 12, price: 450000 },
      { rank: 6, name: 'Grand Stadium',    file: 'arena_rank6', tokens: 15, price: 500000 },
    ],
    pleRank: { name: 'PLE Arena', file: 'arena_rank7', tokens: 1, price: 50000, perPle: true },
  },
  crew: {
    key: 'crew', label: 'Crew',
    icon: '/logistics/crew.png',
    ranks: [
      { rank: 1, name: 'Tour Crew',         file: 'crew_rank1', tokens: 0,  price: 0,      isDefault: true },
      { rank: 2, name: 'Backstage Crew',    file: 'crew_rank2', tokens: 2,  price: 50000  },
      { rank: 3, name: 'Gorilla Crew',      file: 'crew_rank3', tokens: 4,  price: 100000 },
      { rank: 4, name: 'Stage Crew',        file: 'crew_rank4', tokens: 6,  price: 200000 },
      { rank: 5, name: 'Expert Crew',       file: 'crew_rank5', tokens: 8,  price: 300000 },
      { rank: 6, name: 'Veteran Crew',      file: 'crew_rank6', tokens: 10, price: 400000 },
      { rank: 7, name: 'Immortal Crew',     file: 'crew_rank7', tokens: 15, price: 500000 },
    ],
  },
  sfx: {
    key: 'sfx', label: 'Special Effects',
    icon: '/logistics/effects.png',
    ranks: [
      { rank: 1, name: 'Basic Effects',     file: 'effects_rank1', tokens: 0,  price: 0,      isDefault: true },
      { rank: 2, name: 'Stage Lighting',    file: 'effects_rank2', tokens: 2,  price: 50000  },
      { rank: 3, name: 'Pyro Entry',        file: 'effects_rank3', tokens: 4,  price: 100000 },
      { rank: 4, name: 'Stage Show',        file: 'effects_rank4', tokens: 6,  price: 200000 },
      { rank: 5, name: 'Expert FX',         file: 'effects_rank5', tokens: 8,  price: 300000 },
      { rank: 6, name: 'Veteran FX',        file: 'effects_rank6', tokens: 10, price: 400000 },
      { rank: 7, name: 'Immortal FX',       file: 'effects_rank7', tokens: 15, price: 500000 },
    ],
  },
  advertising: {
    key: 'advertising', label: 'Advertising',
    icon: '/logistics/advertising.png',
    ranks: [
      { rank: 1, name: 'Local Flyers',       file: 'advertising_rank1', tokens: 0,  price: 0,      isDefault: true },
      { rank: 2, name: 'Social Media',       file: 'advertising_rank2', tokens: 2,  price: 50000  },
      { rank: 3, name: 'Radio Spots',        file: 'advertising_rank3', tokens: 4,  price: 100000 },
      { rank: 4, name: 'TV Spots',           file: 'advertising_rank4', tokens: 6,  price: 200000 },
      { rank: 5, name: 'Expert Campaign',    file: 'advertising_rank5', tokens: 8,  price: 300000 },
      { rank: 6, name: 'Veteran Campaign',   file: 'advertising_rank6', tokens: 10, price: 400000 },
      { rank: 7, name: 'Immortal Campaign',  file: 'advertising_rank7', tokens: 15, price: 500000 },
    ],
  },
};


// Helper: check if any upgrade is affordable
export const hasAffordableUpgrade = (gameData) => {
  if (!gameData) return false;
  const tokens = gameData.logisticsTokens || 0;
  const budget = gameData.budget || 0;
  const log = gameData.logistics || { arena: 1, crew: 1, sfx: 1, advertising: 1 };
  
  for (const catKey of Object.keys(LOGISTICS_DATA)) {
    const cat = LOGISTICS_DATA[catKey];
    const currentRank = log[catKey] || 1;
    const nextRank = cat.ranks.find(r => r.rank === currentRank + 1);
    if (nextRank && tokens >= nextRank.tokens && budget >= nextRank.price) {
      return true;
    }
  }
  return false;
};

export default function LogisticsTab({ gameData, onUpdateGameData }) {
  var brandColor = (gameData && gameData.brandColor) || '#d4af37';
  var budget = (gameData && gameData.budget) || 0;
  var tokens = (gameData && gameData.logisticsTokens) || 0;
  var logistics = (gameData && gameData.logistics) || { arena: 1, crew: 1, sfx: 1, advertising: 1 };
  var ownedRanks = (gameData && gameData.logisticsOwned) || { arena: [1], crew: [1], sfx: [1], advertising: [1] };
  var weekType = (gameData && gameData.weekType) || 'regular';
  var isPleWeek = weekType === 'ple' || weekType === 'wrestlemania';

  var [confirm, setConfirm] = useState(null);
  var [selectedCat, setSelectedCat] = useState('arena');

  var currentCat = LOGISTICS_DATA[selectedCat];
  var currentRank = logistics[selectedCat] || 1;
  var ownedList = ownedRanks[selectedCat] || [1];
  var currentRankData = currentCat && currentCat.ranks.find(function(r) { return r.rank === currentRank; });

  var handleBuy = function(rank, isPle) {
    var tokenCost = isPle ? currentCat.pleRank.tokens : rank.tokens;
    var price = isPle ? currentCat.pleRank.price : rank.price;
    setConfirm({ catKey: selectedCat, rank, price, tokenCost, isPle });
  };

  var handleEquip = function(rank) {
    onUpdateGameData && onUpdateGameData({
      ...gameData,
      logistics: { ...logistics, [selectedCat]: rank.rank },
    });
  };

  var handleConfirm = function() {
    if (!confirm) return;
    var newOwned = {
      arena: [...(ownedRanks.arena || [1])],
      crew: [...(ownedRanks.crew || [1])],
      sfx: [...(ownedRanks.sfx || [1])],
      advertising: [...(ownedRanks.advertising || [1])],
    };
    var newLogistics = { ...logistics };
    if (!confirm.isPle) {
      if (!newOwned[confirm.catKey].includes(confirm.rank.rank)) {
        newOwned[confirm.catKey] = [...newOwned[confirm.catKey], confirm.rank.rank];
      }
      newLogistics[confirm.catKey] = confirm.rank.rank;
    }
    onUpdateGameData && onUpdateGameData({
      ...gameData,
      budget: budget - confirm.price,
      logisticsTokens: tokens - confirm.tokenCost,
      logistics: newLogistics,
      logisticsOwned: newOwned,
    });
    setConfirm(null);
  };

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <style>{css}</style>

      {/* Confirm modal */}
      {confirm && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.88)', backdropFilter: 'blur(4px)' }}>
          <div style={{ ...S.panel, width: '100%', maxWidth: '360px', padding: '28px', margin: '16px' }}>
            <div style={{ ...S.anton, fontSize: '1rem', letterSpacing: '2px', color: '#d4af37', marginBottom: '6px' }}>CONFIRM PURCHASE</div>
            <div style={{ ...S.mono, fontSize: '0.58rem', color: '#fff', marginBottom: '20px' }}>{confirm.rank.name}</div>
            <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
              <div style={{ flex: 1, background: 'rgba(255,255,255,0.04)', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
                <div style={{ ...S.label, marginBottom: '4px' }}>COST</div>
                <div style={{ ...S.anton, fontSize: '0.85rem', color: '#2ecc71' }}>${confirm.price.toLocaleString('en-US')}</div>
              </div>
              <div style={{ flex: 1, background: 'rgba(255,255,255,0.04)', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
                <div style={{ ...S.label, marginBottom: '4px' }}>TOKENS</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                  <img loading="lazy" src={tokenIcon} alt="" style={{ width: 16, height: 16, objectFit: 'contain' }} onError={function(e){e.target.style.display='none';}} />
                  <span style={{ ...S.anton, fontSize: '0.85rem', color: '#d4af37' }}>{confirm.tokenCost}</span>
                </div>
              </div>
            </div>
            <div style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(255,255,255,0.3)', textAlign: 'center', marginBottom: '20px' }}>
              Remaining: ${(budget - confirm.price).toLocaleString('en-US')} · {tokens - confirm.tokenCost} tokens
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={function() { setConfirm(null); }}
                style={{ flex: 1, ...S.mono, fontSize: '0.48rem', letterSpacing: '1px', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.5)', padding: '10px', borderRadius: '5px', cursor: 'pointer' }}>
                CANCEL
              </button>
              <button onClick={handleConfirm}
                style={{ flex: 2, ...S.anton, fontSize: '0.6rem', letterSpacing: '2px', background: 'rgba(212,175,55,0.15)', border: '1px solid #d4af37', color: '#d4af37', padding: '10px', borderRadius: '5px', cursor: 'pointer' }}>
                CONFIRM
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header — tokens + budget */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingBottom: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)', marginBottom: '16px', flexShrink: 0 }}>
        <div style={{ ...S.anton, fontSize: '1.3rem', letterSpacing: '3px', color: brandColor }}>LOGISTICS</div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.25)', borderRadius: '8px', padding: '8px 14px' }}>
            <img loading="lazy" src={tokenIcon} alt="" style={{ width: 24, height: 24, objectFit: 'contain' }} onError={function(e){e.target.style.display='none';}} />
            <div>
              <div style={{ ...S.label, marginBottom: '1px' }}>TOKENS</div>
              <div style={{ ...S.anton, fontSize: '1rem', color: '#d4af37' }}>{tokens}</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(46,204,113,0.06)', border: '1px solid rgba(46,204,113,0.2)', borderRadius: '8px', padding: '8px 14px' }}>
            <div>
              <div style={{ ...S.label, marginBottom: '1px' }}>BUDGET</div>
              <div style={{ ...S.anton, fontSize: '1rem', color: '#2ecc71' }}>${budget.toLocaleString('en-US')}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Category tabs */}
      <div style={{ display: 'flex', gap: '0', borderBottom: '1px solid rgba(255,255,255,0.08)', marginBottom: '20px', flexShrink: 0 }}>
        {Object.values(LOGISTICS_DATA).map(function(cat) {
          var isActive = selectedCat === cat.key;
          var catRank = logistics[cat.key] || 1;
          return (
            <button key={cat.key} onClick={function() { setSelectedCat(cat.key); }}
              style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', letterSpacing: '1.5px', background: 'transparent', border: 'none', borderBottom: '2px solid ' + (isActive ? brandColor : 'transparent'), color: isActive ? '#fff' : 'rgba(255,255,255,0.35)', padding: '8px 16px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
              <span>{cat.label.toUpperCase()}</span>
              <span style={{ fontSize: '0.36rem', color: isActive ? brandColor : 'rgba(255,255,255,0.25)' }}>RANK {catRank}</span>
            </button>
          );
        })}
      </div>

      {/* Main content — current category */}
      {currentCat && (
        <div style={{ flex: 1, overflowY: 'auto', display: 'flex', gap: '20px' }}>
          {/* LEFT — current rank big image + PLE */}
          <div style={{ width: '340px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ ...S.panel, overflow: 'hidden' }}>
              {/* Category banner */}
              <div style={{ position: 'relative', overflow: 'hidden' }}>
                <img loading="lazy" src={process.env.PUBLIC_URL + currentCat.icon} alt={currentCat.label}
                  style={{ width: '100%', height: '90px', objectFit: 'cover', display: 'block', opacity: 0.7 }}
                  onError={function(e) { e.target.style.opacity='0.05'; }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(0,0,0,0.7) 0%, transparent 60%)', display: 'flex', alignItems: 'center', padding: '0 18px', gap: '10px' }}>
                  <div>
                    <div style={{ ...S.anton, fontSize: '1rem', letterSpacing: '2px', color: '#fff' }}>{currentCat.label.toUpperCase()}</div>
                    <div style={{ ...S.mono, fontSize: '0.46rem', color: brandColor, letterSpacing: '1px' }}>RANK {currentRank} / {currentCat.ranks.length}</div>
                  </div>
                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '4px' }}>
                    {currentCat.ranks.map(function(r) {
                      return <div key={r.rank} style={{ width: '10px', height: '10px', borderRadius: '50%', background: r.rank <= currentRank ? brandColor : 'rgba(255,255,255,0.12)' }} />;
                    })}
                  </div>
                </div>
              </div>
              {/* Active rank image */}
              <div style={{ position: 'relative' }}>
                <img
                  src={process.env.PUBLIC_URL + '/logistics/' + (currentRankData && currentRankData.file) + '.png'}
                  alt={currentRankData && currentRankData.name}
                  style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
                  onError={function(e) { e.target.style.opacity='0.1'; }}
                />
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,0.85))', padding: '24px 18px 12px' }}>
                  <div style={{ ...S.anton, fontSize: '0.9rem', letterSpacing: '2px', color: '#fff' }}>
                    {currentRankData && currentRankData.name.toUpperCase()}
                  </div>
                  <div style={{ ...S.mono, fontSize: '0.46rem', color: brandColor, marginTop: '2px' }}>ACTIVE</div>
                </div>
              </div>
            </div>

            {/* PLE Arena — directly below */}
            {currentCat.pleRank && (
              <div style={{ ...S.panel, overflow: 'hidden' }}>
                <div style={{ position: 'relative' }}>
                  <img
                    src={process.env.PUBLIC_URL + '/logistics/' + currentCat.pleRank.file + '.png'}
                    alt={currentCat.pleRank.name}
                    style={{ width: '100%', height: '120px', objectFit: 'cover', display: 'block', opacity: isPleWeek ? 1 : 0.4 }}
                    onError={function(e) { e.target.style.opacity='0.1'; }}
                  />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(transparent, rgba(0,0,0,0.8))', display: 'flex', alignItems: 'flex-end', padding: '12px 18px' }}>
                    <div>
                      <div style={{ ...S.anton, fontSize: '0.72rem', color: '#d4af37', letterSpacing: '2px' }}>PLE ARENA</div>
                      <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>
                        {isPleWeek ? '✓ Available this week' : '🔒 PLE week only'}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ padding: '12px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', gap: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <img loading="lazy" src={tokenIcon} alt="" style={{ width: 14, height: 14 }} onError={function(e){e.target.style.display='none';}} />
                      <span style={{ ...S.mono, fontSize: '0.46rem', color: 'rgba(255,255,255,0.5)' }}>{currentCat.pleRank.tokens} tokens</span>
                    </div>
                    <span style={{ ...S.mono, fontSize: '0.46rem', color: 'rgba(255,255,255,0.5)' }}>${currentCat.pleRank.price.toLocaleString('en-US')}</span>
                  </div>
                  <button onClick={function() { handleBuy(currentCat.pleRank, true); }}
                    disabled={!isPleWeek || tokens < currentCat.pleRank.tokens || budget < currentCat.pleRank.price}
                    style={{ ...S.anton, fontSize: '0.5rem', letterSpacing: '1.5px', background: isPleWeek && tokens >= currentCat.pleRank.tokens && budget >= currentCat.pleRank.price ? 'rgba(212,175,55,0.15)' : 'transparent', border: '1px solid ' + (isPleWeek && tokens >= currentCat.pleRank.tokens && budget >= currentCat.pleRank.price ? '#d4af37' : 'rgba(255,255,255,0.1)'), color: isPleWeek && tokens >= currentCat.pleRank.tokens && budget >= currentCat.pleRank.price ? '#d4af37' : 'rgba(255,255,255,0.2)', padding: '7px 16px', borderRadius: '4px', cursor: isPleWeek ? 'pointer' : 'not-allowed' }}>
                    {isPleWeek ? 'BUY PLE' : '🔒 PLE ONLY'}
                  </button>
                </div>
              </div>
            )}

            {/* Match Type Unlocks for this category */}
            {(function() {
              var unlocks = Object.entries(LOGISTICS_UNLOCK_MAP)
                .filter(function(entry) { return entry[1].source === selectedCat; })
                .map(function(entry) {
                  var id = entry[0];
                  var info = entry[1];
                  var mt = MATCH_TYPES.find(function(m) { return m.id === id; });
                  var currentCatRank = logistics[selectedCat] || 1;
                  var isUnlocked = currentCatRank >= info.rank;
                  return { id, name: mt ? mt.name : id, rank: info.rank, isUnlocked };
                });
              if (unlocks.length === 0) return null;
              var byRank = {};
              unlocks.forEach(function(u) {
                if (!byRank[u.rank]) byRank[u.rank] = [];
                byRank[u.rank].push(u);
              });
              return (
                <div style={{ ...S.panel, padding: '14px 18px' }}>
                  <div style={{ ...S.label, marginBottom: '12px', fontSize: '0.46rem' }}>🔓 MATCH TYPE UNLOCKS</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {Object.entries(byRank).sort(function(a, b) { return a[0] - b[0]; }).map(function(entry) {
                      var rank = entry[0];
                      var items = entry[1];
                      var allUnlocked = items.every(function(u) { return u.isUnlocked; });
                      return (
                        <div key={rank}>
                          <div style={{ ...S.mono, fontSize: '0.38rem', color: allUnlocked ? 'rgba(46,204,113,0.6)' : 'rgba(255,255,255,0.25)', letterSpacing: '1px', marginBottom: '5px' }}>
                            RANK {rank} {allUnlocked ? '✓' : ''}
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                            {items.map(function(u) {
                              return (
                                <div key={u.id} style={{ ...S.mono, fontSize: '0.44rem', padding: '3px 10px', borderRadius: '4px', border: '1px solid ' + (u.isUnlocked ? 'rgba(46,204,113,0.4)' : 'rgba(255,255,255,0.08)'), color: u.isUnlocked ? '#2ecc71' : 'rgba(255,255,255,0.3)', background: u.isUnlocked ? 'rgba(46,204,113,0.06)' : 'transparent' }}>
                                  {u.isUnlocked ? '' : '🔒 '}{u.name}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
          </div>

          {/* RIGHT — rank list */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {currentCat.ranks.map(function(rank) {
              var isOwned = ownedList.includes(rank.rank);
              var isCurrent = rank.rank === currentRank;
              var canAfford = !isOwned && !rank.isDefault && tokens >= rank.tokens && budget >= rank.price;
              var borderColor = isCurrent ? brandColor : isOwned ? 'rgba(46,204,113,0.4)' : canAfford ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.05)';

              return (
                <div key={rank.rank} className="log-card" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 18px', borderRadius: '8px', border: '1px solid ' + borderColor, background: isCurrent ? brandColor + '0a' : isOwned ? 'rgba(46,204,113,0.04)' : 'rgba(0,0,0,0.3)' }}>
                  {/* Rank image thumbnail */}
                  <div style={{ width: '90px', height: '64px', borderRadius: '6px', overflow: 'hidden', flexShrink: 0 }}>
                    <img loading="lazy" src={process.env.PUBLIC_URL + '/logistics/' + rank.file + '.png'} alt={rank.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: isOwned || rank.isDefault ? 1 : 0.35 }}
                      onError={function(e) { e.target.style.opacity='0.05'; }} />
                  </div>
                  {/* Info */}
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                      <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>RANK {rank.rank}</div>
                      {isCurrent && <div style={{ ...S.mono, fontSize: '0.4rem', color: brandColor, background: brandColor + '18', border: '1px solid ' + brandColor + '44', borderRadius: '2px', padding: '1px 6px', letterSpacing: '1px' }}>ACTIVE</div>}
                      {isOwned && !isCurrent && <div style={{ ...S.mono, fontSize: '0.4rem', color: '#2ecc71', letterSpacing: '1px' }}>✓ OWNED</div>}
                      {rank.isDefault && <div style={{ ...S.mono, fontSize: '0.4rem', color: 'rgba(46,204,113,0.6)', letterSpacing: '1px' }}>DEFAULT</div>}
                    </div>
                    <div style={{ ...S.mono, fontSize: '0.62rem', fontWeight: 'bold', color: isCurrent ? '#fff' : isOwned ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.4)' }}>{rank.name}</div>
                    {!rank.isDefault && (
                      <div style={{ display: 'flex', gap: '14px', marginTop: '5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                          <img loading="lazy" src={tokenIcon} alt="" style={{ width: 13, height: 13 }} onError={function(e){e.target.style.display='none';}} />
                          <span style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(255,255,255,0.35)' }}>{rank.tokens}</span>
                        </div>
                        <span style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(255,255,255,0.35)' }}>${rank.price.toLocaleString('en-US')}</span>
                      </div>
                    )}
                  </div>
                  {/* Action */}
                  {!isOwned && !rank.isDefault && (
                    <button onClick={function() { handleBuy(rank, false); }} disabled={!canAfford}
                      style={{ ...S.anton, fontSize: '0.52rem', letterSpacing: '1.5px', background: canAfford ? 'rgba(212,175,55,0.12)' : 'transparent', border: '1px solid ' + (canAfford ? '#d4af37' : 'rgba(255,255,255,0.08)'), color: canAfford ? '#d4af37' : 'rgba(255,255,255,0.18)', padding: '9px 18px', borderRadius: '4px', cursor: canAfford ? 'pointer' : 'not-allowed', flexShrink: 0 }}>
                      {canAfford ? 'UNLOCK' : '🔒'}
                    </button>
                  )}
                  {isOwned && !isCurrent && (
                    <button onClick={function() { handleEquip(rank); }}
                      style={{ ...S.anton, fontSize: '0.52rem', letterSpacing: '1.5px', background: 'rgba(46,204,113,0.1)', border: '1px solid rgba(46,204,113,0.4)', color: '#2ecc71', padding: '9px 18px', borderRadius: '4px', cursor: 'pointer', flexShrink: 0 }}>
                      EQUIP
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* PLE note */}
      {!isPleWeek && (
        <div style={{ flexShrink: 0, marginTop: '12px', padding: '10px 18px', background: 'rgba(155,89,182,0.07)', border: '1px solid rgba(155,89,182,0.2)', borderRadius: '6px', ...S.mono, fontSize: '0.46rem', color: 'rgba(155,89,182,0.7)', textAlign: 'center' }}>
          ⚡ PLE Arena is only available to purchase on PLE week
        </div>
      )}
    </div>
  );
}
